import { REGULARS } from '../utils';

export const getFileNameFromContentDisposition = (
	contentDisposition: string = '',
): string => {
	const search = contentDisposition.match(REGULARS.fileNameAttachment);

	return search ? search[1] : '';
};
